// src/pages/Villa.jsx
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Import images (Update with actual paths)
import villaImage from '../assets/Villa/111.jpg';
import singleRoomImage from '../assets/Villa/f3.jpg';
import familyRoomImage from '../assets/Villa/6.jpg';
import seaBathImage from '../assets/Villa/sea.jpg';

const Villa = () => {
    return (
        <section className="container my-5">
            {/* Villa Description and Image Section */}
            <div className="row align-items-center">
                {/* Left Side - Villa Description */}
                <div className="col-md-6 order-md-1 order-2 mt-4 mt-md-0">
                    <h1 className="display-5 fw-bold" style={{ color: '#819371' }}>Cinnamon Mantra Luxury Villa</h1>
                    <p className="lead">
                        Nestled in the heart of paradise, Cinnamon Mantra Luxury Villa offers
                        a serene escape surrounded by breathtaking landscapes and luxurious comforts.
                        The villa boasts modern architecture blended with traditional aesthetics,
                        ensuring an unforgettable stay.
                    </p>
                    <p>
                        Guests can enjoy private pools, world-class dining, and personalized
                        services, making it the perfect retreat for families, couples, and solo travelers.
                        Whether you're looking for relaxation or adventure, this villa is designed to cater to
                        your every need.
                    </p>
                </div>

                {/* Right Side - Villa Image */}
                <div className="col-md-6 text-center order-md-2 order-1">
                    <img
                        src={villaImage}
                        alt="Cinnamon Mantra Luxury Villa"
                        className="img-fluid rounded shadow-lg"
                        style={{ borderRadius: '20px' }}
                    />
                </div>
            </div>

            {/* Our Rooms Section */}
            <section className="text-center my-5">
                <h2 className="fw-bold display-4" style={{ color: '#819371' }}>Our Rooms</h2>
                <p className="text-muted mb-4 w-75 mx-auto">
                    Experience luxury and comfort in our exquisitely designed rooms.
                    Whether you're traveling solo or with family, we have the perfect accommodation for you.
                </p>

                {/* Room Cards */}
                <div className="row justify-content-center">
                    {/* Single Room */}
                    <div className="col-md-6 col-lg-5 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
                            <div className="position-relative">
                                <img
                                    src={singleRoomImage}
                                    alt="Single Room"
                                    className="card-img-top"
                                    style={{ height: '350px', objectFit: 'cover', transition: 'transform 0.3s ease-in-out' }}
                                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                />
                                <div className="position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white py-3">
                                    <h3 className="mb-0">Apartment Room</h3>
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <p className="text-success fw-bold fs-4">$30 / Per Night</p>
                                <a href="/apartment-room" className="btn btn-success btn-lg">View Details</a>
                            </div>
                        </div>
                    </div>

                    {/* Family Room */}
                    <div className="col-md-6 col-lg-5 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
                            <div className="position-relative">
                                <img
                                    src={familyRoomImage}
                                    alt="Family Room"
                                    className="card-img-top"
                                    style={{ height: '350px', objectFit: 'cover', transition: 'transform 0.3s ease-in-out' }}
                                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                />
                                <div className="position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white py-3">
                                    <h3 className="mb-0">Apartment Rooms with Villa</h3>
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <p className="text-success fw-bold fs-4">$50 / Per Night</p>
                                <a href="/apartment-rooms-villa" className="btn btn-success btn-lg">View Details</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sea Bath Near the Villa Section */}
            <section className="my-5">
                <div className="row align-items-center">
                    {/* Left Side - Image */}
                    <div className="col-md-6 text-center order-md-1 order-2 mt-4 mt-md-0">
                        <img
                            src={seaBathImage}
                            alt="Sea Bath Near the Villa"
                            className="img-fluid rounded shadow-lg"
                            style={{ borderRadius: '20px' }}
                        />
                    </div>

                    {/* Right Side - Description */}
                    <div className="col-md-6 order-md-2 order-1">
                        <h2 className="fw-bold display-5" style={{ color: '#819371' }}>Sea Bath Near the Villa</h2>
                        <p className="lead">
                            Just a short walk from the villa, you will find crystal-clear waters perfect for a refreshing sea bath.
                            Whether you're looking to relax or enjoy some water activities, the stunning shoreline offers
                            the perfect escape.
                        </p>
                        <p>
                            With the gentle waves and scenic ocean views, the experience of sea bathing here is truly rejuvenating.
                            Guests can also indulge in beachfront dining, sunset views, and a variety of water sports activities.
                        </p>
                    </div>
                </div>
            </section>
            {/* Important Notices Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold mb-4 display-4" style={{ color: '#819371' }}>Important Notices</h2>
                <div className="d-flex justify-content-center">
                    <ul className="list-unstyled text-center">
                        <li className="mb-3">
                            <strong className="text-success">✔ Free Boat Safari:</strong> Guests who stay for more than 10 days will enjoy a complimentary boat safari.
                        </li>
                        <li className="mb-3">
                            <strong className="text-success">✔ Free Tuk Tuk for City Transport:</strong> Guests who stay for more than 10 days will receive free tuk tuk transportation for exploring the city.
                        </li>
                        <li className="mb-3">
                            <strong className="text-success">✔ Airport Transportation:</strong> Guests who stay for more than 30 days will incur an airport transportation cost of Rs. 10,000.

                        </li>
                    </ul>
                </div>
            </section>


        </section>
    );
};

export default Villa;